import THREE from "./Three";
import sceneObserver from "./Observer";
import { loadingManager } from "./Loader";
import Heading from "./Heading/Heading";
import Scene from "./Background/Scene";
import Background from "./Background/Background";

const Init = () => {
  const canvas = document.getElementById("app");

  let activeCanvas = null;
  const scenes = [];

  const [
    headingSection,
    backgroundSection,
    lightSection,
    pixelSection,
    footerSection,
  ] = [
    document.getElementById("lotus-display"),
    document.getElementById("blooming-scene"),
    document.getElementById("light-scene"),
    document.getElementById("pixel-scene"),
    document.getElementById("lotus-footer"),
  ];

  const [headingScene, backgroundScene, lightScene, pixelScene, footerScene] = [
    new THREE.Scene(),
    new THREE.Scene(),
    new THREE.Scene(),
    new THREE.Scene(),
    new THREE.Scene(),
  ];

  const manager = loadingManager();

  const setScenes = (currScene, currSection) => {
    const sceneElement = currSection.querySelector(".scene");
    currScene.userData.element = sceneElement;

    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    currScene.userData.camera = camera;
    currScene.position.set(0, 0, 0);
    scenes.push(currScene);
  };

  const setRenderer = () => {
    const renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
    });

    renderer.setClearColor(0xffffff, 1);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight, false);
    renderer.shadowMap.enabled = true;
    renderer.domElement.willReadFrequently = true;

    return renderer;
  };

  const setSubjects = () => {
    const headingClass = new Heading(headingScene, manager);
    const backgroundClass = new Background(backgroundScene, renderer);
    const lightClass = new Scene(lightScene, renderer);
    const pixelClass = new Scene(pixelScene, renderer);
    const footerClass = new Scene(footerScene, renderer);

    const subjects = [
      headingClass,
      backgroundClass,
      lightClass,
      pixelClass,
      footerClass,
    ];

    return subjects;
  };

  setScenes(headingScene, headingSection);
  setScenes(backgroundScene, backgroundSection);
  setScenes(lightScene, lightSection);
  setScenes(pixelScene, pixelSection);
  setScenes(footerScene, footerSection);

  const renderer = setRenderer();
  const subjects = setSubjects();

  sceneObserver(subjects);

  const animate = () => {
    requestAnimationFrame(animate);
    render();
  };

  const render = () => {
    //  canvas.style.transform = `translateY(${window.scrollY}px)`;

    renderer.setClearColor(0xffffff);
    renderer.setScissorTest(false);
    renderer.clear();

    renderer.setClearColor(0xe0e0e0);
    renderer.setScissorTest(true);

    scenes.forEach((scene, index) => {
      let element = scene.userData.element;
      let camera = scene.userData.camera;

      const rect = element.getBoundingClientRect();

      const width = rect.right - rect.left;
      const height = rect.bottom - rect.top;

      if (!element.parentNode.classList.contains("active")) return;

      const left = rect.left;
      const bottom = renderer.domElement.clientHeight - rect.bottom;

      camera.aspect = width / height;
      camera.updateProjectionMatrix();

      renderer.setViewport(left, bottom, width, height);
      renderer.setScissor(left, bottom, width, height);

      const active = subjects[index];

      if (activeCanvas === null) {
        activeCanvas = active;
      }

      if (activeCanvas === active) {
        active.render();

        if (active.triggerEffects) {
          active.triggerEffects();
        }
      }
    });
  };

  animate();

  window.addEventListener("scroll", () => {
    let newActiveCanvas = null;

    scenes.forEach((scene, index) => {
      let element = scene.userData.element;
      if (element.parentNode.classList.contains("active")) {
        newActiveCanvas = subjects[index];
      }
    });

    if (newActiveCanvas !== activeCanvas) {
      activeCanvas = newActiveCanvas;
    }
  });
};

export default Init;
